import React, { Component } from "react";

import "./Header.css";

import Button from "@material-ui/core/Button";
import Menu from "@material-ui/icons/Menu";
import Drawer from "@material-ui/core/Drawer";

export default class Header extends Component {
  constructor(props) {
    super(props);
    this.state = {
      drawerOpen: false,
      displayRoute: props.displayRoute,
    };
    this.routes = [
      {
        name: "Home",
        link: "/",
      },
      {
        name: "About",
        link: "/about",
      },
      {
        name: "Departments",
        link: "/departments",
      },
      {
        name: "Services",
        link: "/services",
      },
      {
        name: "Find a Doctor",
        link: "/doctors",
      },
      // {
      //   name: "Blog",
      //   link: "/blog",
      // },
      {
        name: "TPA & Corporate",
        link: "/tpa-corporate",
      },
      {
        name: "Contact",
        link: "/contact",
      },
      {
        name: "Schedule Now",
        link: "/book-now",
      },
    ];
  }

  componentDidUpdate(prevProps) {
    if (this.props.history.location.pathname !== prevProps.history.location.pathname) {
      this.setState({ drawerOpen: false });
    }
  }

  navigateTo = (route) => {
    this.props.history.push(route);
    this.toggleDrawer(false);
  };

  toggleDrawer = (toggle) => {
    this.setState({ drawerOpen: toggle });
  };

  scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
    this.setState({ drawerOpen: false });
  };

  render() {
    return (
      <header className="header">
        {/* <div className="nav-row-1">
          <div className="nav-logos">
            <Button color="primary" variant="contained" onClick={() => this.navigateTo("/registration")}>
              Register Now
            </Button>
            <img src="/logo-1.png" alt="Logo" />
            <img src="/department_logo.png" alt="ISN Logo" />
          </div>
        </div> */}
        <div className="nav-row-2">
          <div className="nav-wrapper">
            {/* logo image */}
            <div className="logo" onClick={() => this.navigateTo("/")}>
              <img src="/logo_white.png" alt="logo" />
              <img src="/nabh300.png" alt="logo" style={{ width: "65px" }} />
            </div>
            {/* nav links */}

            <nav className="nav-links">
              {this.routes.map((route, index) => {
                if (route.link === "/book-now") {
                  return (
                    <Button variant="contained" color="primary" className="book-now-btn" onClick={() => this.navigateTo("/book-now")}>
                      {route.name}
                    </Button>
                  );
                }
                return (
                  <Button key={index} className="link-btn" onClick={() => this.navigateTo(route.link)}>
                    {route.name}
                  </Button>
                );
              })}
            </nav>

            <div className="header-menu-bar">
              <Menu fontSize="large" onClick={() => this.toggleDrawer(true)} />
            </div>
            <Drawer anchor="right" open={this.state.drawerOpen} onClose={(e) => this.toggleDrawer(false)}>
              <div className="drawer-wrapper">
                <div className="drawer-content">
                  <img src="/footer-logo.png" alt="logo" className="drawer-logo" onClick={() => this.navigateTo("/")} />
                  {this.routes.map((route, index) => {
                    if (route.link === "/book-now") {
                      return (
                        <Button variant="contained" color="primary" className="book-now-btn" onClick={() => this.navigateTo("/book-now")}>
                          {route.name}
                        </Button>
                      );
                    }
                    return (
                      <Button key={index} className="drawer-link-btn" onClick={() => this.navigateTo(route.link)}>
                        {route.name}
                      </Button>
                    );
                  })}
                </div>
              </div>
            </Drawer>
          </div>
        </div>
      </header>
    );
  }
}
